export const validateKey = () => (value) => value;
//# sourceMappingURL=validate-key.js.map